import React from "react";


const Section4 = ({url}) => {
  return (
   <section className="home-section-4">
      <div className="container overflow-hidden">

        <div className="section4-header" data-aos="fade-up">
          <h2 className="section4-title">
            <span className="first">Simple Transformation</span> <br />
            From <span className="gradient-text">Chaos</span> to{" "}
            <span className="gradient-text">Control</span>
          </h2>
        </div>

        <div className="comparison-grid" data-aos="fade-up" data-aos-delay="200">

          {/* Left Card - Traditional */}
          <div className="comparison-card traditional">
            <h4 className="card-heading">Traditional Document Management</h4>
            <ul className="card-list">
              <li>Manual access control that relies on human oversight and creates security gaps</li>
              <li>Scattered collaboration across emails, external tools, and unsecured file sharing</li>
              <li>Zero audit visibility into who accessed, edited, or shared sensitive documents</li>
              <li>Reactive compliance violations discovered after the damage is done</li>
              <li>Cloud dependency: Your sensitive data is stored on third-party infrastructure</li>
            </ul>
          </div>

          {/* Right Card - Concord */}
          <div className="comparison-card modern"
          
           style={{
                // backgroundImage: `url("https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe")`,
                backgroundImage: `url("${url}images/concord/section-4/modern-back.png")`,
                backgroundSize: "60%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
            }
          }
          >
            <h4 className="card-heading">
              With <span className="gradient-text">AI Document Management System</span>
            </h4>
            <ul className="card-list">
              {[
                "Automated role-based access AI enforces the right permissions without manual intervention",
                "Secure in-platform collaboration within a fully governed, controlled environment",
                "Complete audit trail of every document interaction in real time",
                "Proactive compliance—every action tracked, logged, and audit-ready automatically",
                "On-premises deployment, complete data sovereignty, your infrastructure, zero external dependency",
              ].map((text, i) => (
                <li key={i}>
                  <img src={`${url}images/concord/section-4/star.png`} alt="" className="star-icon" />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Section4;
